import TablePagination from '@mui/material/TablePagination';

type ListPaginatorProps = {
  totalCount: number;
  page: number;
  rowsPerPage: number;
  setPage: (page: number) => void;
  setRowsPerPage: (rowsPerPage: number) => void;
};

export default function ListPaginator({
  totalCount,
  page,
  rowsPerPage,
  setPage,
  setRowsPerPage,
}: ListPaginatorProps) {
  return (
    <TablePagination
      component="div"
      count={totalCount}
      rowsPerPage={rowsPerPage}
      page={page}
      labelDisplayedRows={({ from, to }) => {
        if (from === to) {
          return `${from}件中 ${from}件目を表示`;
        }
        return `${from}件中 ${from}-${to}件目を表示`;
      }}
      onPageChange={(_, newPage) => {
        setPage(newPage);
      }}
      onRowsPerPageChange={(event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
      }}
    />
  );
}
